import React from 'react'
import Colors from 'utils/Colors'
import { DATA_FIELDS_NAMES } from 'utils/constants/dataFields'

import styles from './styles'

function QuestionsStatus(props) {
  const { questions } = props
  const classes = styles()
  return (
    <div className={classes.root}>
      <div className={classes.header}>
        <h2>Status das respostas do formulário</h2>
      </div>
      {Object.keys(questions).map((question) => {
        const filled = questions[question]
        return (
          <div key={question} className={classes.listItem}>
            <span>{DATA_FIELDS_NAMES[question]}</span>
            <span
              className={classes.status}
              style={{ backgroundColor: filled ? Colors.green : Colors.googleYellow }}
            >
              {filled ? 'Salvo' : 'Pendente'}
            </span>
          </div>
        )
      })}
    </div>
  )
}

export default QuestionsStatus
